import React from "react";
import { bg_color_green, textContent, titleContent } from "../../Style";
import { ExploreSolution } from "../../buttons/Buttons";
import AiGirl from "../../assets/RPA/AI-Girl.png";
export const RPAHeader = () => {
  return (
    <div className="flex flex-col gap-0 pb-8">
      <div
        className={`${bg_color_green}  w-full h-fit text-white flex flex-col gap-10`}
      >
        <div className="cssanimation sequence fadeInBottom w-full h-fit flex flex-row  flex-wrap gap-5 justify-center items-center pt-8 px-8 mobile:px-2 mobile:pt-2 mobile:pb-10 ipadMin:pt-4">
          <div className="w-fit laptop:max-w-[65%] largeScreen:max-w-[50%] text-left min-h-[500px] h-fit flex flex-col justify-center gap-10 mobile:gap-3 mobile:min-h-0">
            <div className="flex flex-col gap-5 w-full ipadMin:items-center ipadMax:items-center">
              <div className="flex gap-1 items-center w-fit text-white py-2 px-5 bg-[#5A8031] border border-[#809E5D] rounded-[24px] text-base mobile:text-xs mobile:px-2 mobile:w-full">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                >
                  <path
                    d="M6.83033 4.086C7.27883 2.7735 9.09233 2.73375 9.62408 3.96675L9.66908 4.08675L10.2743 5.85675C10.413 6.26267 10.6372 6.63413 10.9317 6.94607C11.2261 7.258 11.5841 7.50316 11.9813 7.665L12.1441 7.72575L13.9141 8.33025C15.2266 8.77875 15.2663 10.5922 14.0341 11.124L13.9141 11.169L12.1441 11.7743C11.738 11.9129 11.3664 12.137 11.0543 12.4314C10.7423 12.7259 10.497 13.0839 10.3351 13.4813L10.2743 13.6432L9.66983 15.414C9.22133 16.7265 7.40783 16.7662 6.87683 15.534L6.83033 15.414L6.22583 13.644C6.08721 13.2379 5.86311 12.8663 5.56863 12.5543C5.27416 12.2422 4.91617 11.9969 4.51883 11.835L4.35683 11.7743L2.58683 11.1698C1.27358 10.7212 1.23383 8.90775 2.46683 8.37675L2.58683 8.33025L4.35683 7.72575C4.76275 7.58704 5.13421 7.3629 5.44615 7.06843C5.75808 6.77396 6.00324 6.41602 6.16508 6.01875L6.22583 5.85675L6.83033 4.086ZM14.2501 1.5C14.3904 1.5 14.5279 1.53936 14.6469 1.6136C14.766 1.68785 14.8618 1.794 14.9236 1.92L14.9596 2.00775L15.2221 2.77725L15.9923 3.03975C16.1329 3.08752 16.2562 3.17596 16.3465 3.29386C16.4368 3.41176 16.4901 3.55381 16.4995 3.70202C16.509 3.85022 16.4743 3.9979 16.3997 4.12634C16.3252 4.25478 16.2142 4.3582 16.0808 4.4235L15.9923 4.4595L15.2228 4.722L14.9603 5.49225C14.9125 5.63282 14.824 5.75602 14.706 5.84624C14.5881 5.93647 14.446 5.98964 14.2978 5.99904C14.1496 6.00844 14.002 5.97363 13.8736 5.89903C13.7452 5.82443 13.6418 5.7134 13.5766 5.58L13.5406 5.49225L13.2781 4.72275L12.5078 4.46025C12.3672 4.41248 12.244 4.32404 12.1537 4.20614C12.0634 4.08824 12.0101 3.94619 12.0006 3.79798C11.9911 3.64978 12.0259 3.5021 12.1004 3.37366C12.175 3.24522 12.2859 3.1418 12.4193 3.0765L12.5078 3.0405L13.2773 2.778L13.5398 2.00775C13.5904 1.85957 13.6861 1.73093 13.8135 1.63987C13.9408 1.54882 14.0935 1.49991 14.2501 1.5Z"
                    fill="white"
                  />
                </svg>
                <div>LEADING AUTONOMY REVOLUTION</div>
              </div>
              <div
                className={`${titleContent} w-full  ipadMax:text-center ipadMin:text-center font-[200] mobile:text-center`}
              >
                <span className="font-semibold">
                  Orchestrating the <br /> Synergy of <br />{" "}
                  <span className="font-semibold text-[#F5E04D]">
                    Humans,Robots
                  </span>{" "}
                  and
                  <br />
                  Agentic AI
                </span>
              </div>
              <div
                className={`text-[#D5DECB] text-[16px] md:text-[18px] self-stretch justify-start font-normal leading-6 tracking-wider w-full ipadMax:text-center ipadMin:text-center mobile:text-center px-4 md:px-0`}
              >
                Welcome to our world of great customer service. Together let's
                embark on a remarkable journey where dreams become tangible
                realities through autonomous intelligence.
              </div>
            </div>
            <div className="h-fit w-full flex flex-row flex-wrap mobile:justify-center ipadMin:justify-center ipadMax:justify-center">
              <ExploreSolution />
            </div>
          </div>
          <div className="flex-1 min-w-[270px] w-full flex justify-center items-center relative group">
            <div
              className="z-10 w-full max-w-[600px] h-72 
  border-[12px] md:border-[18px] border-[#368C18] 
  rounded-[12px] 
  hover:scale-[1.02] hover:rotate-1 
  transition-all duration-700 shadow-xl group"
            >
              <div className="w-full h-full rounded-[6px] overflow-hidden">
                <img
                  src={AiGirl}
                  alt="AI"
                  className="w-full h-full object-cover block 
      group-hover:scale-110 
      transition-transform duration-1000"
                />
              </div>
            </div>
            <div
              className="
      absolute -bottom-10 left-5 mobile:-bottom-20 z-10
      p-4
      rounded-[16.571px]
      bg-white/40
      backdrop-blur-[22px]
      shadow-[0_3.899px_3.899px_rgba(0,0,0,0.25)]
      text-white
      w-[180px] md:w-[220px]
      hover:-translate-y-2 transition-transform duration-500 cursor-default
    "
            >
              <div className="flex gap-2 items-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="29"
                  height="29"
                  viewBox="0 0 29 29"
                  fill="none"
                >
                  <rect width="29" height="29" rx="6" fill="#5A8031" />
                  <path
                    d="M16.8992 12.0872C16.8992 12.6874 17.3863 13.1744 17.9864 13.1744H18.9867L16.0686 16.0925C16.0349 16.1262 15.9949 16.153 15.9509 16.1713C15.9069 16.1896 15.8597 16.199 15.812 16.199C15.7643 16.199 15.7171 16.1896 15.6731 16.1713C15.6291 16.153 15.5891 16.1262 15.5554 16.0925L13.2563 13.7934C12.7807 13.318 12.1357 13.051 11.4632 13.051C10.7907 13.051 10.1457 13.318 9.67 13.7934L6.34603 17.1174C6.23922 17.2169 6.15354 17.3369 6.09412 17.4703C6.0347 17.6037 6.00274 17.7476 6.00017 17.8936C5.99759 18.0396 6.02445 18.1846 6.07913 18.32C6.13381 18.4553 6.2152 18.5783 6.31844 18.6816C6.42168 18.7848 6.54465 18.8662 6.68003 18.9209C6.81541 18.9756 6.96041 19.0024 7.10639 18.9998C7.25237 18.9973 7.39634 18.9653 7.5297 18.9059C7.66306 18.8465 7.78309 18.7608 7.88263 18.654L11.2066 15.33C11.2403 15.2962 11.2802 15.2695 11.3243 15.2512C11.3683 15.2329 11.4155 15.2235 11.4632 15.2235C11.5108 15.2235 11.558 15.2329 11.6021 15.2512C11.6461 15.2695 11.6861 15.2962 11.7198 15.33L14.0188 17.6291C14.4945 18.1044 15.1395 18.3715 15.812 18.3715C16.4845 18.3715 17.1295 18.1044 17.6052 17.6291L20.5233 14.7125V15.7112C20.5233 15.9996 20.6378 16.2761 20.8417 16.48C21.0456 16.6839 21.3221 16.7985 21.6105 16.7985C21.8988 16.7985 22.1754 16.6839 22.3792 16.48C22.5831 16.2761 22.6977 15.9996 22.6977 15.7112V12.0872C22.6977 11.7989 22.5831 11.5223 22.3792 11.3184C22.1754 11.1145 21.8988 11 21.6105 11H17.9864C17.6981 11 17.4216 11.1145 17.2177 11.3184C17.0138 11.5223 16.8992 11.7989 16.8992 12.0872Z"
                    fill="white"
                  />
                </svg>
                <div className="text-sm font-medium text-white">
                  Efficiency Gain
                </div>
              </div>

              <div className="text-3xl font-bold text-[#1D4111] mt-2">
                +340%
              </div>

              <div className="text-xs text-[#EFEFEF]">
                Through Agentic Workflows
              </div>
            </div>
            <div className="absolute right-0 top-1/2 translate-y-[-20%] z-0 laptop:block">
              <div className="border-[20px] border-[#FBE204]/30 rounded-full w-[180px] h-[180px] absolute -right-5 top-20"></div>

              <div className="border-2 border-[#FBE204]/30 rounded-full w-[180px] h-[180px] absolute -right-0 top-40"></div>
            </div>
          </div>
        </div>

        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 80 1440 180"
          className="mt-[-8%] ipadMax:mt-[-6%] largeScreen:mt-[0%] "
        >
          <path
            fill="#ffffff"
            className=" bg-white"
            fillOpacity="100"
            d="M0,192L48,208C96,224,192,256,288,250.7C384,245,480,203,576,165.3C672,128,768,96,864,85.3C960,75,1056,85,1152,112C1248,139,1344,181,1392,202.7L1440,224L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
          ></path>
        </svg>
      </div>
      <div className="flex flex-col gap-4 justify-center place-items-center w-full">
        <div
          className={`${titleContent}  font-semibold  w-full  text-center text-[#1A1A1A]`}
        >
          Turning{" "}
          <span className="relative inline-block">
            <span className="text-[#79B400]">Ideas</span>
            <span className="absolute left-1/2 -translate-x-1/2 bottom-[-4px] w-[60%] h-[4px] bg-[#F9E100] rounded-full"></span>
          </span>
          <span> into </span>
          <span className="  text-[#2D6A00]">Real</span>
        </div>
        <div className={`w-[40%] text-[#6B7280] text-center mobile:w-full`}>
          Discover how Teja Technologies is leading the autonomy revolution by
          bridging the gap between static code and dynamic intuition.
        </div>
      </div>
    </div>
  );
};
